import type { CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveDomain = (state: CoreState): string | undefined => {
  return findActiveBrand(state)?.domain ?? undefined
}
